import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords, image }) => {
  const ogImage = image || 'https://limbism.com/limbism_logo.png';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://limbism.com" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Limbism | Contemporary Pop Art Prints & NFTs',
  description: 'Limbism is a contemporary digital artist creating limited edition pop art prints, NFTs, and custom works. Each edition capped at 50, signed, numbered, with Certificate of Authenticity. Inspired by Murakami and Kusama.',
  keywords: 'Limbism, pop art, contemporary art, limited edition prints, NFT art, digital art, flower series, pop culture art, buy art prints, custom art commission, art collector',
  image: 'https://limbism.com/limbism_logo.png',
};

export default Meta;
